<template>
  <div class="muit-qa">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <i class="el-icon-arrow-left back-icon" @click="goBack()"></i>
      <span class="title">多元智能测试</span>
      <div class="capsule"></div>
    </div>

    <div v-if="questions.length === 0" class="loading">
      <p>加载题库中...</p>
    </div>
    <div v-else class="qa-container">
      <!-- 当前部分标题 -->
      <div class="section-title">{{ questions[currentQuestion].sift }}</div>

      <!-- 进度徽章 -->
      <div class="progress-badge">
        <span class="current">{{ currentQuestion + 1 }}</span>
        <span class="total">/{{ questions.length }}题</span>
      </div>

      <!-- 问题卡片 -->
      <div class="question-card">
        <div class="question-text">
          {{ questions[currentQuestion] ? questions[currentQuestion].text : "" }}
        </div>

        <!-- 选项 -->
        <div class="options">
          <div
            class="option"
            :class="{ active: selectedOption === 'A' }"
            @click="selectOption('A')"
          >
            <span class="option-label">1.</span>
            <span class="option-text">符合</span>
          </div>
          <div
            class="option"
            :class="{ active: selectedOption === 'B' }"
            @click="selectOption('B')"
          >
            <span class="option-label">2.</span>
            <span class="option-text">不符合</span>
          </div>
        </div>
      </div>

      <!-- 按钮区域 -->
      <div class="button-section">
        <button
          class="back-button"
          @click="prevQuestion"
          :disabled="currentQuestion === 0"
          v-if="currentQuestion > 0"
        >
          返回上一题
        </button>
        <button
          v-if="currentQuestion === questions.length - 1 && selectedOption"
          class="submit-button"
          @click="submitTest"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? "提交中..." : "提交" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getWechatUserProfile } from "@/assets/js/wechatAuth";

export default {
  name: "MUITQA",
  data() {
    return {
      currentQuestion: 0,
      selectedOption: "",
      answers: [],
      questions: [],
      originalData: [],
      isSubmitting: false,
    };
  },
  computed: {
    currentSection() {
      // 根据题目序号返回对应的智能类型部分
      const sections = [
        "第一部分：语言智能",
        "第二部分：逻辑数学智能",
        "第三部分：空间智能",
        "第四部分：音乐智能",
        "第五部分：身体动觉智能",
        "第六部分：人际智能",
        "第七部分：内省智能",
        "第八部分：自然观察智能",
      ];
      // 每部分5题，共40题
      const sectionIndex = Math.floor(this.currentQuestion / 5);
      return sections[sectionIndex] || sections[7];
    },
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    fetchQuestions() {
      this.$get("http://59.110.51.52:8010/system/web/survey?wjId=3")
        .then((res) => {
          if (res.data && res.data.topicTianBaos) {
            this.originalData = res.data;
            this.originalData.name = this.generateUUID();
            this.questions = res.data.topicTianBaos.map((topic) => ({
              id: topic.tmId,
              text: topic.tmName,
              sift: topic.sift,
              optionAId: topic.optionTianBaos[0].xxId,
              optionBId: topic.optionTianBaos[1].xxId,
              optionAXh: topic.optionTianBaos[0].xxXh,
              optionBXh: topic.optionTianBaos[1].xxXh,
            }));
          }
        })
        .catch((err) => {
          console.error("获取题库失败:", err);
        });
    },

    goBack() {
      this.$router.push("/muit-action");
    },

    selectOption(option) {
      this.selectedOption = option;
      this.answers[this.currentQuestion] = option;

      // 自动进入下一题（最后一题除外）
      if (this.currentQuestion < this.questions.length - 1) {
        setTimeout(() => {
          if (this.currentQuestion < this.questions.length - 1) {
            this.currentQuestion++;
            this.selectedOption = this.answers[this.currentQuestion] || "";
          }
        }, 500);
      }
    },

    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.selectedOption = this.answers[this.currentQuestion] || "";
      }
    },

    submitTest() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;

      const wechatUser = getWechatUserProfile();

      const submitData = {
        ...this.originalData,
        name: this.originalData.name || this.generateUUID(),
        topicTianBaos: this.originalData.topicTianBaos.map((topic, index) => ({
          ...topic,
          optionTianBaos: topic.optionTianBaos.map((option) => ({
            ...option,
            is_opt: this.answers[index] === option.xxXh ? 1 : 0,
          })),
        })),
        brief: wechatUser.brief || "",
        openid: wechatUser.openid || "",
        nickName: wechatUser.nickName || "",
        sex: wechatUser.sex === "" ? "" : wechatUser.sex,
        headimgurl: wechatUser.headimgurl || "",
      };

      localStorage.setItem("muitTestName", submitData.name);
      localStorage.setItem("muitTestWjId", "3");

      const openid = wechatUser.openid || "";


      this.$post("http://59.110.51.52:8010/system/web/addsurvey", submitData)
        .then((res) => {
          if (res && res.code === 200) {
            this.$router.push({
              path: "/muit-result",
              query: { openid: openid, wjId: "3" },
            });
          } else {
            this.$router.push({
              path: "/muit-result",
              query: { openid: openid, wjId: "3" },
            });
          }
        })
        .catch((err) => {
          console.error("提交失败:", err);
          this.$router.push({
            path: "/muit-result",
            query: { openid: openid, wjId: "3" },
          });
        })

        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.muit-qa {
  height: 100vh;
  max-width: 375px;
  margin: 0 auto;
  background: linear-gradient(180deg, #efffed 0%, #f8fff8 100%);
  padding: 12px 14px 24px;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.back-icon {
  font-size: 22px;
  color: #1c2a1c;
  cursor: pointer;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #1c2a1c;
}



.loading {
  min-height: 56vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #768276;
  font-size: 14px;
}

.qa-container {
  min-height: calc(100vh - 86px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section-title {
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 800;
  color: #33ab45;
  text-align: center;
}

.progress-badge {
  position: relative;
  z-index: 9;
  margin-bottom: -14px;
  padding: 6px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffe79e 0%, #ffd86e 100%);
  box-shadow: 0 4px 10px rgba(238, 190, 70, 0.35);
}

.progress-badge .current {
  font-size: 15px;
  color: #9d6f2c;
  font-weight: 700;
}

.progress-badge .total {
  font-size: 12px;
  color: rgba(157, 111, 44, 0.8);
  font-weight: 700;
}

.question-card {
  width: 100%;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #e9f5ea;
  box-shadow: 0 3px 12px rgba(99, 156, 106, 0.13);
  padding: 28px 14px 20px;
  min-height: 386px;
  display: flex;
  flex-direction: column;
}

.question-text {
  flex: 1;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  line-height: 1.6;
  color: #4c5670;
  font-weight: 600;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.option {
  height: 54px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8fb;
  cursor: pointer;
}

.option.active {
  background: linear-gradient(90deg, #8bdb58 0%, #53c67b 100%);
}

.option-label,
.option-text {
  font-size: 17px;
  color: #525d74;
  font-weight: 600;
}

.option-label {
  margin-right: 6px;
}

.option.active .option-label,
.option.active .option-text {
  color: #fff;
}

.button-section {
  width: 100%;
  display: flex;
  gap: 14px;
  margin-top: 50px;
  padding-top: 24px;
}

.back-button,
.submit-button {
  flex: 1;
  height: 50px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 700;
}

.back-button {
  background: #c7cbce;
  color: #fff;
}

.submit-button {
  background: linear-gradient(90deg, #fbcc1f 0%, #f39f02 100%);
  color: #fff;
}

.back-button:disabled,
.submit-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
